import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';

const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/daily-work'),
      name: 'daily_work_settings',
      roles: ['administrator'],
      redirect: to => ({
        name: 'daily_task_settings',
        params: to.params,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/settings/daily-task'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'Daily Task',
        icon: 'clipboard',
        showNewButton: false,
        keepAlive: false,
      },
      children: [
        {
          path: '',
          name: 'daily_task_settings',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};
